/**
 * Detects iOS devices including iPhones, iPads, and iPod Touch.
 * Also handles iPad iOS 13+ detection when requesting desktop sites.
 *
 * @returns {boolean} true if running on an iOS device, false otherwise
 */
export const isIOS = (): boolean => {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    // iPad on iOS 13+ detection when requesting desktop sites
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
};

export const isSafariDesktop = (): boolean => {
  const userAgent = navigator.userAgent;

  if (!userAgent.includes("Safari") || !userAgent.includes("Version/")) {
    return false;
  }

  if (/Chrome|Chromium|Edge|CriOS|FxiOS|EdgiOS/.test(userAgent)) {
    return false;
  }

  if (/Mobile|Android|iPhone|iPod|iPad|Tablet/.test(userAgent)) {
    return false;
  }

  if (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) {
    return false;
  }

  // Verify actual macOS desktop: must have Mac identifiers and Intel architecture
  return (userAgent.includes("Macintosh") || userAgent.includes("Mac OS X")) && userAgent.includes("Intel");
};
